// extracted by mini-css-extract-plugin
export default {"globalContent":"index_globalContent_pVCDM","globalItem":"index_globalItem_cxLZY","globalBoldText":"index_globalBoldText_J6tkA","globalThinText":"index_globalThinText_nNxZf"};